import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, IconButton } from "@material-ui/core";
import { makeStyles } from '@material-ui/styles';
import firebase from "../../config/firebase/index";
import encSecret from '../../config/encryption/index.js';
import NoFollowMeta from '../../component/NofollowMeta/index.jsx';
import { Header } from 'antd/lib/layout/layout';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Fab, Table, TableBody, TableContainer, TableRow, Menu, MenuItem } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import TableDash from '../../component/TableAtom/index.jsx';
import { useHistory } from 'react-router-dom';


const Sales_Dashboard = (props) => {

    const classes = useStyles();
    const history = useHistory();
    const [user, setUser] = useState();
    const [userName, setUserName] = useState();
    const isSalesLoggedIn = localStorage.getItem("isSalesLoggedIn");
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [productDetails, setProductDetails] = useState();
    const [salesUser, setSalesUser] = useState();
    const openM = Boolean(anchorEl);
    const [dateRange, setDateRange] = useState();


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);

    };

    const handleLogout = () => {
        localStorage.removeItem('salesUser');
        history.push("/sales");
    }

    const calculateDates = () => {
        let date = new Date();
        let dates = [];
        for (let i = 0; i < 8; i++) {
            dates.push(date.toLocaleString('en-IN', { day: 'numeric', month: 'short' }));
            date.setDate(date.getDate() - 1);
        }
        console.log(dates);
        setDateRange(dates);
    }

    const formatDates = (d) => {
        let dd = d.split("-");
        let newDATE = dd[1] + "/" + dd[2] + "/" + dd[0];
        let date = new Date(newDATE);
        return date.toLocaleString('en-IN', { day: 'numeric', month: 'short' });
    }

    const filteredUser = (data) => {
        let users = [];
        for (let user of data) {
            if (user && user.dealerFlag)
                users.push(user)
        }
        return users;
    }

    const calc = (arr, type) => {
        let count = 0;
        for (let ar of arr) {
            count = count + parseInt(ar.analytics[type] ? ar.analytics[type] : 0);
        }
        return count;

    }

    const calculateData = (deals) => {
        let result = {};
        for (let key in deals) {
            // if (deals && Object.keys(deals) && Object.keys(deals).length)
            // Object.keys(deals).forEach(key => {
            if (!result[key]) result[key] = {};
            result[key]["views"] = calc(deals[key], "views");
            result[key]["phone"] = calc(deals[key], "phone");
            result[key]["whatsapp"] = calc(deals[key], "whatsapp");
            result[key]["suggest"] = calc(deals[key], "suggest");
            result[key]["deals"] = deals[key].length;
        };
        console.log("Deals ::: ", result);
        return result;
    }

    const formatMonthDate = (num) => {
        return parseInt(num) > 9 ? num : "0" + num ;
    }


    const getProducts = (sUsersArrUnfiltered) => {
        let sUsersArr = filteredUser(sUsersArrUnfiltered);
        let date = new Date();
        date.setDate(date.getDate());
        calculateDates();
        let endDate = date.getFullYear() + "-" + formatMonthDate(date.getMonth() + 1) + "-" + formatMonthDate(date.getDate());
        let endTime = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
        date.setDate(date.getDate() - 7);
        let startDate = date.getFullYear() + "-" + formatMonthDate(date.getMonth() + 1) + "-" + formatMonthDate(date.getDate());

        console.log(startDate, endDate, endTime);

        firebase.database().ref("Product").orderByChild("createdAt")
            .startAt(startDate).endAt(endDate + " " + endTime).on("value", snapshot => {

                let productData = snapshot.val();
                let formatedDetails = {};
                for (let key in productData) {
                    // Object.keys(productData).forEach(key => {
                    if (!formatedDetails[productData[key].DealerNumber])
                        formatedDetails[productData[key].DealerNumber] = {};
                    let fDate = productData[key].createdAt.split(" ")[0];
                    if (!formatedDetails[productData[key].DealerNumber][formatDates(fDate)])
                        formatedDetails[productData[key].DealerNumber][formatDates(fDate)] = [];
                    formatedDetails[productData[key].DealerNumber][formatDates(fDate)].push(productData[key]);
                };
                setProductDetails(formatedDetails);
                let clients = sUsersArr;
                if (clients && formatedDetails) {
                    for (let client of clients) {
                        client["deals"] = formatedDetails[client.PhoneNo];
                        client["dealsSummarize"] = {};
                        client["dealsSummarize"] = calculateData(client["deals"]);
                    }
                    console.log("C::::", clients);

                    setSalesUser(clients);
                }

            });
    }

    const getData = (user) => {
        let dealerIds = user.dealerIds;
        let sUsersArr = [];
        console.log(dealerIds);
        for (let id of dealerIds) {

            firebase.database().ref("Users/" + (id).trim()).on("value", snapshot => {
                const sUsers = snapshot.val();
                console.log(sUsers);
                sUsersArr.push(sUsers);
                if (dealerIds.length == sUsersArr.length) {
                    // console.log("SUsers :::", sUsersArr);
                    getProducts(sUsersArr);
                }
            });

        }

    }


    useEffect(() => {
        if (!localStorage.getItem("salesUser"))
            history.push("/sales");
        else {
            let usr = JSON.parse(localStorage.getItem("salesUser"));
            console.log("Usr ::: ", usr);
            if (usr) {
                setUser(usr[0]);
                setUserName(usr[0].name);
                getData(usr[0]);
            }

        }

    }, [])


    return (
        <>
            <NoFollowMeta />

            <Grid p={2} className={classes.commonSectionBuild}>
                <Header>
                    <Typography variant="h6" style={{ fontWeight: 600, padding: 20 }} >
                        Saudebazi - Sales Dashboard
                    </Typography>
                    {(user && user.isAuthorized) ?
                        <Box>
                            <Button
                                id="basic-button"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick}
                                style={{ marginLeft: 20, fontSize: 20, textTransform: 'none', color: 'black' }}
                            >
                                {'Hi ' + (userName ? userName : 'userName')} <ExpandMoreIcon fontSize='large' />
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={openM}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                            </Menu>
                        </Box>
                        : <></>
                    }


                </Header>
                <Box>
                    <Typography variant="h5" style={{ fontWeight: 600, padding: 20, paddingTop: 10, paddingBottom: 5 }} >
                        Your clients
                    </Typography>
                </Box>
                {
                    (salesUser) ?
                        <TableDash dateRange={dateRange} clients={salesUser} />
                        :
                        <></>
                }
            </Grid>
        </>
    )
};


const useStyles = makeStyles(() => ({
    drawerDesign: {
        '& .MuiDrawer-paper': {
            paddingTop: 20,
            borderRadius: '20px 20px 0 0',
        }
    },
    headerBrowser: {
        background: '#53252f',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    kishanDetail: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    textCenterSet: {
        display: 'flex',
        alignItems: 'center',
    },
    rotateSHareIcon: {
        transform: 'rotateY(360deg)',
    },
    contetnArrange: {
        width: '100%',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        '& div': {
            width: '100%'
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        float: 'none',
        margin: '0 auto'
    },
    manageIconCenter: {
        justifyContent: 'center',
        padding: '50px 0 20px',
        boxSizing: 'border-box',
    },
    image: {
        width: '35px',
        height: '35px',
        borderRadius: '50%',
        position: 'relative',
        overflow: 'hidden',
    },
    footerFixed: {
        position: 'fixed',
    },

    dealerCall: {
        width: '55%',
        padding: '10px 20px',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '200px',
        marginLeft: '60px',
    }
}));

export default Sales_Dashboard;